<!-- KYMW1205 移動先のＰコード指定 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">Ｐコード指定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <!-- Ｐコード -->
          <div class="list-input-title">Ｐコード</div>
          <div class="list-input-content">
          <input type="text" class="list-input-content pcode" id="txti_PCode" [(ngModel)]="model.pCode"
            plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" [tabindex]="0" />
          </div>
        </div>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button id="btn_Set" #btn_Set class="btn-primary" (click)="eventConfirm_CLICKHandler()" [tabindex]="0" forcedEnabledMode="true">確定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>